import { render, staticRenderFns } from "./Metal.vue?vue&type=template&id=66913eb4"
import script from "./Metal.vue?vue&type=script&lang=js"
export * from "./Metal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports